import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import chrono from 'chrono-node'

import { gridCreateTime } from 'actions/grid'
import GridHeaderTimeAdd from './grid-header-time-add'

export class GridHeaderTimeAddContainer extends Component {

  constructor(props) {
    super(props)

    this.state = { adding: false }

    this.handleAdd = this.handleAdd.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  handleAdd() {
    this.setState({ adding: true })
  }

  handleSubmit(data) {
    const date = chrono.parseDate(data.time)
    if (date) {
      this.props.gridCreateTime(date.getHours(), date.getMinutes())
    }
    this.setState({ adding: false })
    this.props.resetForm()
  }

  render() {
    return (
      <GridHeaderTimeAdd
        {...this.props}
        {...this.state}
        onAdd={this.handleAdd}
        onSubmit={this.props.handleSubmit(this.handleSubmit)}
      />
    )
  }

}

GridHeaderTimeAddContainer.propTypes = {
  fields: PropTypes.object,
  gridCreateTime: PropTypes.func,
  handleSubmit: PropTypes.func,
  resetForm: PropTypes.func.isRequired,
  style: PropTypes.object,
}

const form = 'GridHeaderTimeAddContainer'
const fields = ['time']

const mapStateToProps = (state, ownProps) => ({ ...ownProps })

export default reduxForm({ form, fields })(connect(mapStateToProps, { gridCreateTime })(GridHeaderTimeAddContainer))



/** WEBPACK FOOTER **
 ** ./src/components/grid/grid-header-time-add/grid-header-time-add-container.js
 **/